import React from "react";
import { Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import HomePage from "./components/Homepage";
import Services from "./components/Services";
import About from "./components/About";
import Team from "./components/Team";
import Portfolio from "./components/Portfolio";
import Careers from "./components/Careers";
import Contact from "./components/Contact";
import CareerApply from "./components/CareerApply";
import Blog from "./components/Blog";

export default function App() {
  return (
    <>
      <Navbar />

      <main className="pt-5">
        <Routes>
          {/* Homepage: all sections */}
          <Route path="/" element={<HomePage />} />

          {/* Separate pages */}
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/team" element={<Team />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/careers" element={<Careers />} />
           <Route path="/careers/:jobId/apply" element={<CareerApply />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </main>

      <Footer />
    </>
  );
}
